module.exports = __webpack_public_path__ + "img/A04.5df781c6.jpg";